const STORAGE_KEY = "pendingRecordingDeletions";

export interface PendingRecordingDeletion {
  recordingUUID: string;
  deviceKey: string;
  timestamp: number;
}

// See docs/recording-upload-retry.md for why this queue exists.
function readQueue(): PendingRecordingDeletion[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];

    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.log("pendingRecordingDeletions: failed to read queue, resetting it:", error);
    return [];
  }
}

function writeQueue(queue: PendingRecordingDeletion[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(queue));
  } catch (error) {
    console.log("pendingRecordingDeletions: failed to persist queue:", error);
  }
}

export function addPendingRecordingDeletion(recordingUUID: string, deviceKey: string): void {
  const queue = readQueue();
  if (queue.some((entry) => entry.recordingUUID === recordingUUID)) return;

  writeQueue([...queue, { recordingUUID, deviceKey, timestamp: Date.now() }]);
}

export function removePendingRecordingDeletion(recordingUUID: string): void {
  const queue = readQueue();
  writeQueue(queue.filter((entry) => entry.recordingUUID !== recordingUUID));
}

export function getPendingRecordingDeletions(): PendingRecordingDeletion[] {
  return readQueue();
}
